<template>
<div>
  <HLS-Player :playerData="this.statis" @onStats="onStats" @onPeerID="onPeerID" @onPeers="onPeers" />
  <Charts :lineData="lineData" />
</div>
</template>

<script>
import Player from '../components/Player'
import Charts from '../components/Charts'
import { getQueryParam } from '../utils/tools'

let url = 'https://video.cdnbye.com/0cf6732evodtransgzp1257070836/e0d4b12e5285890803440736872/v.f100220.m3u8'

export default {
  name: 'Player',
  beforeCreate() {
    const param = getQueryParam('url') || undefined
    if(param) {
      // const param = search.split('?url=')[1]

      url = decodeURIComponent(param)
    }
  },
  data() {
    return {
      statis: {
        url,
        offload: '0',
        ratio: '0',
        upload: '0',
        peers: '0',
        buffers: 0,
        peerID: '',
      },
      lineData: {
        series1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        series2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    }
  },
  components: {
    Charts,
    'HLS-Player': Player
  },
  methods: {
    onStats({ totalHTTPDownloaded=0, totalP2PDownloaded=0, totalP2PUploaded=0 }) {
      var total = totalHTTPDownloaded + totalP2PDownloaded
      this.statis.ratio = Math.round(totalP2PDownloaded / total * 100)
      this.statis.offload = (totalP2PDownloaded / 1024).toFixed(2)
      this.statis.upload = (totalP2PUploaded / 1024).toFixed(2)
    },
    onPeerID(id) {
      this.statis.peerID = id
    },
    onPeers(peers) {
      this.statis.peers = peers.length
    },
    onFogLoaded({url, sn, segId, loaded, duration, byP2p, fromPeerId}) {
      if (byP2p) {
          this.lineData.series2.push((loaded / 1024).toFixed())
          this.lineData.series1.push(0)
      } else {
          this.lineData.series1.push((loaded / 1024).toFixed())
          this.lineData.series2.push(0)
      }
      this.lineData.series1.shift()
      this.lineData.series2.shift()
    },
    HLSerror(event, data) {
      const errDetails = Hls.ErrorDetails
      switch (data.details) {
        case errDetails.BUFFER_STALLED_ERROR:
          this.statis.buffers ++
          break
      }
    },
  },
}
</script>
